module.exports = __webpack_public_path__ + "img/gcloud.8c699d13.png";